export const PARAPLANNING_BONUS_BANDS = [
  { percentage: 105, bonus: 300 },
  { percentage: 110, bonus: 450 },
  { percentage: 115, bonus: 600 },
  { percentage: 120, bonus: 750 },
  { percentage: 125, bonus: 900 },
  { percentage: 130, bonus: 1050 },
  { percentage: 135, bonus: 1200 },
  { percentage: 140, bonus: 1350 },
  { percentage: 145, bonus: 1500 },
  { percentage: 150, bonus: 1650 },
  { percentage: 155, bonus: 1800 },
  { percentage: 160, bonus: 1950 },
  { percentage: 165, bonus: 2100 },
  { percentage: 170, bonus: 2250 },
  { percentage: 175, bonus: 2400 },
  { percentage: 180, bonus: 2550 },
  { percentage: 185, bonus: 2700 },
  { percentage: 190, bonus: 2850 },
  { percentage: 195, bonus: 3000 },
];

export const normaliseParaplanningEmail = (email = "") =>
  String(email || "")
    .trim()
    .toLowerCase();

export const formatParaplanningCurrency = (value = 0) => {
  const number = Number(value || 0);

  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
    maximumFractionDigits: 2,
  }).format(number);
};

export const formatParaplanningPercent = (value = 0) => {
  const number = Number(value || 0);

  if (!Number.isFinite(number)) return "0%";

  return `${number.toFixed(1)}%`;
};

export const getQuarterStartMonthKey = (quarterKey = "") => {
  const [year, quarterValue] = String(quarterKey).split("-Q");
  const quarter = Number(quarterValue);

  if (!year || !quarter) return "";

  const month = String((quarter - 1) * 3 + 1).padStart(2, "0");

  return `${year}-${month}`;
};

export const getPeriodStartMonthKey = (
  periodKey = "",
  summaryMode = "quarter",
) => {
  if (!periodKey) return "";

  if (summaryMode === "quarter") {
    return getQuarterStartMonthKey(periodKey);
  }

  return periodKey;
};

export const getAnnualSalaryForPeriod = ({
  salaryRecord = {},
  selectedPeriodKey = "",
  summaryMode = "quarter",
}) => {
  const periodStartMonthKey = getPeriodStartMonthKey(
    selectedPeriodKey,
    summaryMode,
  );

  const history = Array.isArray(salaryRecord.salaryHistory)
    ? salaryRecord.salaryHistory
    : [];

  const sortedHistory = [...history]
    .filter((item) => item?.effectiveFromMonth && item?.annualSalary)
    .sort((a, b) =>
      String(a.effectiveFromMonth).localeCompare(String(b.effectiveFromMonth)),
    );

  const matchingRecord = sortedHistory
    .filter((item) => String(item.effectiveFromMonth) <= periodStartMonthKey)
    .at(-1);

  return Number(
    matchingRecord?.annualSalary || salaryRecord?.annualSalary || 0,
  );
};

export const getSalaryForSummaryMode = (
  annualSalary = 0,
  summaryMode = "quarter",
) => {
  const salary = Number(annualSalary || 0);

  if (!salary) return 0;

  if (summaryMode === "month") {
    return salary / 12;
  }

  return salary / 4;
};

export const getChargeVsSalaryPercentage = ({
  chargeTotal = 0,
  salaryForPeriod = 0,
}) => {
  const charge = Number(chargeTotal || 0);
  const salary = Number(salaryForPeriod || 0);

  if (!salary) return 0;

  return (charge / salary) * 100;
};

export const getParaplanningBonusAmount = (chargeVsSalaryPercentage = 0) => {
  const percentage = Number(chargeVsSalaryPercentage || 0);

  const matchedBand = [...PARAPLANNING_BONUS_BANDS]
    .reverse()
    .find((band) => percentage >= band.percentage);

  return matchedBand?.bonus || 0;
};

export const hasBonusBlockingGrade = (cases = []) => {
  return cases.some((item = {}) => {
    const possibleGrades = [
      item.paraplanningGrade,
      item.qualityGrade,
      item.grade,
      item.reviewGrade,
      item.auditGrade,
      item.bonusGrade,
      item.complianceGrade,
      item?.quality?.grade,
      item?.review?.grade,
    ];

    return possibleGrades.some((grade) => {
      const value = String(grade || "")
        .trim()
        .toLowerCase();

        return (
          true
        // value === "3" ||
        // value === "4" ||
        // value === "grade 3" ||
        // value === "grade 4" ||
        // value.includes("grade 3") ||
        // value.includes("grade 4")
      );
    });
  });
};
